package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.components.AppDropdownTextField
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.resources.AppResources

@Composable
internal fun ColumnScope.CityCardView(
    selectedCity: String?,
    cities: List<String>,
    callbacks: SearchFilterCallbacks,
) {
    CardView {
        Text(
            text = AppResources.strings.searchFilterLocationCityLabel,
            style = AppTextStyles.bodyMediumRegular,
            color = MaterialTheme.colors.onSurfacePrimary
        )
        AppSpacer(12.dp)
        AppDropdownTextField(
            placeholder = AppResources.strings.searchFilterLocationCityPlaceholder,
            selectedItem = selectedCity,
            items = cities.toSet(),
            onValueChanged = { callbacks.onCityValueChanged(it) },
        )
    }
}